import { render, staticRenderFns } from "./report-detail-table.vue?vue&type=template&id=c3e65466"
import script from "./report-detail-table.vue?vue&type=script&lang=js"
export * from "./report-detail-table.vue?vue&type=script&lang=js"
import style0 from "./report-detail-table.vue?vue&type=style&index=0&id=c3e65466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports